'use strict';

module.exports = {
    desktop: {
        dp: {
            home: [],
            dp: [
                'login',
                'simplified_disclaimer',
                'dp_search_summary',
                'dp_automatic_refresh',
                'dp_error_management',
                'accommodation_details',
                'accommodation_details_gallery',
                'accommodation_summary',
                'accommodation_details_information',
                'accommodation_reviews',
                'accommodation_details_conditions',
                'accommodation_details_policies',
                'resident_discount_message',
                'accommodation_filter_by_category',
                'app_checkin',
                'download_app_banner',
                'dp_search_no_results',
                'accommodation_filter_by_review',
                'collapsible_flight_summary',
            ],
            secure: [
                'app_checkin',
                'get_your_guide',
                'login',
                'psd2_popup_manager',
                'psd2_communication_popup',
                'resident_discount',
                'repricing_popup_manager',
                'gt_standalone_banner',
                'collapsible_flight_summary',
                'download_app_banner',
                'hand_baggage_summary',
                'baggage_summary',
                'boarding_options',
                'aircraftmap_manager',
                'aircraftmap_legend',
                'ancillaries',
                'baggage_wrapper',
                'baggage_passenger',
                'baggage_segment',
            ],
        },
        flights: {
            secure: [
                'accommodation_summary',
                'account_blocked',
                'account_preferences_manager',
                'app_checkin',
                'download_app_banner',
                'hand_baggage_summary',
                'baggage_summary',
                'bags_and_seats_offline',
                'aircraftmap_manager',
                'aircraftmap_legend',
                'boarding_options',
                'ancillaries',
                'baggage_wrapper',
                'baggage_passenger',
                'baggage_segment',
                'collapsible_flight_summary',
                'drawer',
                'frequent_passengers_manager',
                'get_your_guide',
                'insurance_content',
                'login',
                'login_expired_manager',
                'membership_account_billing',
                'membership_benefits',
                'membership_billing_information',
                'membership_cancel_account',
                'membership_customer_service',
                'membership_default_billing',
                'membership_prime_ancillaries',
                'my_trips',
                'name_on_card_field',
                'cvv2_field',
                'psd2_popup_manager',
                'psd2_communication_popup',
                'resident_discount',
                'post_booking_accommodation',
                'post_booking_accommodation_header',
                'register_manager',
                'repricing_popup_manager',
                'reset_password_manager',
                'share_itinerary',
                'gt_standalone_banner',
                'section_details',
            ],
            home: [
                'login',
                'login_expired_manager',
            ],
        },
        upsell: {
            secure: [
                'repricing_popup_manager',
                'get_your_guide',
                'login',
                'accommodation_details',
                'accommodation_filter_by_category',
                'accommodation_filter_by_review',
                'download_app_banner',
            ],
            home: [],
        },
        accommodationPostBooking: {
            secure: [
                'login',
                'repricing_popup_manager',
                'get_your_guide',
                'accommodation_details',
                'gt_standalone_banner',
                'download_app_banner',
            ],
            home: [],
        },
    },
    mobile: {
        dp: {
            home: [
                'app_touchpoint',
                'download_app_banner',
                'edit_option_meta',
                'login',
            ],
            dp: [
                'app_touchpoint',
                'download_app_banner',
                'progress_indicator',
                'dp_search_summary',
                'dp_automatic_refresh',
                'dp_error_management',
                'accommodation_details_gallery',
                'accommodation_results_manager',
                'accommodation_hotel_card',
                'accommodation_map_manager',
                'accommodation_summary',
                'accommodation_filter_by_category',
                'accommodation_details_conditions',
                'accommodation_details_policies',
                'login',
                'accommodation_filter_by_review',
                'collapsible_flight_summary',
                'resident_discount_message',
            ],
            secure: [
                'app_touchpoint',
                'download_app_banner',
                'buyer',
                'buyer_widget',
                'login',
                'payment_button',
                'progress_indicator',
                'psd2_popup_manager',
                'resident_discount',
                'psd2_communication_popup',
                'dp_search_summary',
                'repricing_popup_manager',
                'collapsible_flight_summary',
                'accommodation_hotel_card',
            ],
        },
        flights: {
            secure: [
                'download_app_banner',
                'accommodation_results_manager',
                'accommodation_hotel_card',
                'accommodation_map_manager',
                'accommodation_summary',
                'account_blocked',
                'account_preferences_manager',
                'app_touchpoint',
                'bags_and_seats_offline',
                'buyer_widget',
                'collapsible_flight_summary',
                'drawer',
                'freecancel_banner',
                'flex_pop_up',
                'frequent_passengers_manager',
                'edit_option_meta',
                'insurance_content',
                'login',
                'login_expired_manager',
                'membership_account_billing',
                'membership_benefits',
                'membership_billing_information',
                'membership_cancel_account',
                'membership_customer_service',
                'membership_default_billing',
                'membership_subscription_details',
                'membership_prime_ancillaries',
                'my_trips',
                'psd2_popup_manager',
                'resident_discount',
                'psd2_communication_popup',
                'name_on_card_field',
                'cvv2_field',
                'payment_button',
                'post_booking_accommodation',
                'register_manager',
                'repricing_popup_manager',
                'reset_password_manager',
                'xsell_confirmation_eml',
                'section_details',
                'waiting_blocks',
            ],
            home: [
                'edit_option_meta',
                'app_touchpoint',
                'login',
                'waiting_blocks',
            ],
        },
        upsell: {
            secure: [
                'payment_button',
                'collapsible_flight_summary',
                'edit_option_meta',
                'login',
                'buyer_widget',
                'repricing_popup_manager',
                'psd2_popup_manager',
                'psd2_communication_popup',
                'accommodation_filter_by_category',
                'accommodation_filter_by_review',
                'freecancel_banner',
                'download_app_banner',
            ],
            home: [],
        },
    },
};
